<mat-toolbar color="primary">
    <a mat-flat-button color="primary" routerLink="" routerLinkActive="router-link-active navMenuItemActive"
        [routerLinkActiveOptions]="{exact:true}">Club</a>
    <a mat-flat-button color="primary" routerLink="termine"
        routerLinkActive="router-link-active navMenuItemActive">Termine</a>
    <a mat-flat-button color="primary" routerLink="boote"
        routerLinkActive="router-link-active navMenuItemActive">Boote</a>
    <a mat-flat-button color="primary" routerLink="jugend"
        routerLinkActive="router-link-active navMenuItemActive">Jugend</a>
    <a mat-flat-button color="primary" routerLink="regatta"
        routerLinkActive="router-link-active navMenuItemActive">Regatta</a>
    @if(breakpointService.breakpoint() === 'DESKTOP') {
    <a mat-flat-button color="primary" routerLink="links"
        routerLinkActive="router-link-active navMenuItemActive">Links</a>
    }
    <a mat-flat-button color="primary" routerLink="kontakt"
        routerLinkActive="router-link-active navMenuItemActive">Kontakt</a>
    @if(breakpointService.breakpoint() === 'DESKTOP') {
    <a mat-flat-button color="primary" routerLink="wetter"
        routerLinkActive="router-link-active navMenuItemActive">Wetter</a>
    }
    <a mat-flat-button color="primary" routerLink="videos"
        routerLinkActive="router-link-active navMenuItemActive">Videos</a>
    <a mat-flat-button color="primary" routerLink="member"
        routerLinkActive="router-link-active navMenuItemActive">Mitglieder</a>
    <!-- <a mat-flat-button color="primary"><mat-icon>more</mat-icon></a> -->
</mat-toolbar>